import React, { useState, useEffect } from "react";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useForm } from "react-hook-form";
import PointSpreadLoading from "react-loadingg/lib/PointSpreadLoading";
import { Link, useHistory } from "react-router-dom";
import {
  checkDiscount,
  getCurrent,
  GetShoppingCartFinal,
  sendToIdPayPostApi,
} from "../../Api/BarestServices";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import { separate } from "../../Seprate/Seprate";
import { errorToast, succToast } from "../../Toast/Toast";
import Style from "./FinalizePurchase.module.css";
import { Radio } from "antd";

const FinalizePurchase = () => {
  const [DataCart, setDataCart] = useState();
  const [deliverPrice, setDeliverPrice] = useState();
  const [newPrice, setNewPrice] = useState();
  const [currentLocations, setCurrentLocations] = useState();
  const [load, setLoad] = useState(false);
  const [getDoor, setGetDoor] = useState(true);
  const [walletState, setWalletState] = useState(false);
  const [disable, setDisable] = useState(false);
  const [disablePay, setDisablePay] = useState(false);
  const [code, setCode] = useState("");
  const { register, handleSubmit } = useForm();

  let history = useHistory();

  useEffect(() => {
    GetFinalCart();
    CurrentAddres();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //////// get final payment info //////////////
  const GetFinalCart = async () => {
    GetShoppingCartFinal((succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast("مشکلی پیش آمده است");
        } else {
          if (res.status === 0) {
            errorToast(res.message);
            setTimeout(() => {
              history.push("/shopp");
            }, 500);
          } else {
            setDataCart(res.cart);
            setDeliverPrice(res.delivery_price);
          }
        }
      } else {
        console.error(res);
      }
    });
  };

  let TotallPrice = 0;
  ///////// send to idpay page /////////////
  const onSubmitHandler = (data) => {
    setDisable(true);
    setCode(data.code);
    let Code = {
      code: data.code,
    };
    checkDiscount(Code, (res) => {
      if (res.status === 0) {
        setDisable(false);
        errorToast(res.message);
        setCode("")
      } else {
        setDisable(false);
        succToast("تخفیف با موفقیت اعمال شد");
        setNewPrice(res.total);
      }
    });
  };
  ///////// get user current address ///////////
  const CurrentAddres = async () => {
    getCurrent((succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast("مشکلی پیش آمده است");
        } else {
          setCurrentLocations(res.address);
        }
      } else {
        console.error(res);
      }
    });
  };

  let LoadingHandler = null;
  if (DataCart === undefined) {
    LoadingHandler = (
      <PointSpreadLoading
        color={"#ab0c59"}
        size={"small"}
        style={{ margin: "8rem 0" }}
      />
    );
  } else {
    DataCart.forEach((element) => {
      TotallPrice += parseInt(element.total);
    });
    LoadingHandler = DataCart.map((item, index) => {
      return (
        <div key={index} className={Style.holderBuy}>
          <div className={Style.logoHolder}>
            <img
              src={`//cdn.barest.ir/supplier/logo/${item.logo}.jpg`}
              alt="رستوران"
            />
          </div>
          <div className={Style.NameHolder}>
            <h3>سبدخرید {index + 1}:</h3>
            <p>{item.name}</p>
            <span className={Style.spanBuy}>{separate(item.total)} تومان </span>
          </div>
        </div>
      );
    });
  }
  //////link to idPay ///////////
  const sendToIdPay = () => {
    if (value === 1) {
      errorToast("بتدا درگاه موردنظر را مشخص کنید");
    } else {
      setDisablePay(true);
      setLoad(true);
      let info = {
        code: code === "" ? "" : code,
        where_to_deliver: getDoor ? "in" : "out",
        delivery_price: getDoor ? deliverPrice.in : deliverPrice.out,
        wallet: walletState,
        payment_type: value,
      };
      sendToIdPayPostApi(info, (res) => {
        if (res.status === 1) {
          setDisablePay(false);
          window.open(res.link, "_self");
          setLoad(false);
        } else {
          setLoad(false);
          setDisablePay(false);
          errorToast(res.message);
        }
      });
    }
  };

  const [value, setValue] = useState("pgw");
  const onChange = (e) => {
    setValue(e.target.value);
  };

  let totalPayment = null;

  if (getDoor && walletState) {
    totalPayment = separate(
      Math.max(
        0,
        deliverPrice &&
          deliverPrice.in + TotallPrice - localStorage.getItem("wallet")
      )
    );
  } else if (getDoor && !walletState) {
    totalPayment = separate(
      Math.max(0, deliverPrice && deliverPrice.in + TotallPrice)
    );
  } else if (!getDoor && walletState) {
    totalPayment = separate(
      Math.max(0, TotallPrice - localStorage.getItem("wallet"))
    );
  } else {
    totalPayment = separate(deliverPrice && deliverPrice.out + TotallPrice);
  }

  return (
    <section className={Style.pageHolder}>
      <BurgerMenuTitle title={"سفارش نهایی"} />
      {load ? (
        <div className={Style.loading}>
          <PointSpreadLoading color={"#ab0c59"} size={"small"} />
        </div>
      ) : (
        <div className={Style.listHolder}>
          <div className={Style.currentAddress}>
            <h2 className={Style.addressPart}>
              <FontAwesomeIcon
                icon={faMapMarkerAlt}
                className={Style.markerIcon}
              />
              {currentLocations &&
                "شهر: " +
                  currentLocations.city +
                  "," +
                  "روستا: " +
                  currentLocations.region +
                  "," +
                  "خیابان: " +
                  currentLocations.street +
                  "," +
                  "کوچه: " +
                  currentLocations.alley +
                  "," +
                  "," +
                  "ساختمان: " +
                  currentLocations.apartment_name +
                  "," +
                  "واحد: " +
                  currentLocations.apartment_number +
                  "," +
                  "پلاک: " +
                  currentLocations.plate +
                  "," +
                  currentLocations.description}
            </h2>
            <Link to={"/changeaddress"} className={Style.changeLink}>
              <h2 className={Style.change}>تغییر آدرس</h2>
            </Link>
          </div>
          {LoadingHandler}
          <div className={Style.liftHolder}>
            <input
              className={Style.checkInput}
              type={"checkbox"}
              onChange={(e) => setGetDoor(e.target.checked)}
              checked={getDoor}
              id="doorReceive"
            />
            <label htmlFor="doorReceive">درب منزل تحویل میگیرم</label>
          </div>
          {localStorage.getItem("wallet") === "0" ? null : (
            <div className={Style.liftHolder}>
              <input
                className={Style.checkInput}
                type={"checkbox"}
                onChange={(e) => setWalletState(e.target.checked)}
                checked={walletState}
                id="wallet"
              />
              <label htmlFor="wallet">
                {" "}
                برداشت از کیف پول{" "}
                <p>{`(${separate(localStorage.getItem("wallet"))} تومان)`}</p>
              </label>
            </div>
          )}

          <div className={Style.payPart}>
            <form
              onSubmit={handleSubmit(onSubmitHandler)}
              className={Style.discount}
            >
              <button
                disabled={disable}
                className={Style.btnDiscount}
                type={"submit"}
              >
                اعمال
              </button>
              <input
                {...register("code", { required: true })}
                className={Style.inputHolder}
                type={"text"}
                placeholder={"کدتخفیف"}
              />
            </form>
            <div className={Style.totalHolder}>
              <h3
                style={{
                  fontFamily: "iran-sans-num",
                  direction: "rtl",
                  color: "green",
                }}
              >
                {separate(TotallPrice)} <span>تومان</span>
              </h3>
              <h3 className={Style.total}> : مبلغ کل خرید </h3>
            </div>
            <br />
            <hr />
            <div className={Style.totalHolder}>
              {newPrice > 0 ? (
                <h3
                  style={{
                    fontFamily: "iran-sans-num",
                    direction: "rtl",
                    color: "green",
                  }}
                >
                  {" "}
                  {separate(newPrice)} <span>تومان</span>
                </h3>
              ) : (
                <h3
                  style={{
                    fontFamily: "iran-sans-num",
                    direction: "rtl",
                    color: "green",
                  }}
                >
                  {separate(TotallPrice)} <span>تومان</span>
                </h3>
              )}
              <h3 className={Style.total}> : مبلغ با تخفیف </h3>
            </div>
            <br />
            <hr />
            <div className={Style.totalHolder}>
              <h3
                style={{
                  fontFamily: "iran-sans-num",
                  direction: "rtl",
                  color: "green",
                }}
              >
                {getDoor
                  ? separate(deliverPrice && deliverPrice.in)
                  : separate(deliverPrice && deliverPrice.out)}{" "}
                <span>تومان</span>
              </h3>
              <h3 className={Style.total}> : هزینه پیک </h3>
            </div>
            <br />
            <hr />
            <div className={Style.totalHolder}>
              <h3
                style={{
                  fontFamily: "iran-sans-num",
                  direction: "rtl",
                  color: "green",
                }}
              >
                {/* {getDoor && walletState
                  ? separate(deliverPrice && deliverPrice.in + TotallPrice -parseInt 

                    )
                  : separate(
                      deliverPrice && deliverPrice.out + TotallPrice
                    )}{" "} */}
                {separate(
                  newPrice > 0
                    ? (getDoor ? deliverPrice?.in : deliverPrice?.out) +
                        newPrice
                    : (getDoor ? deliverPrice?.in : deliverPrice?.out) +
                        TotallPrice
                )}
                <span> تومان</span>
              </h3>
              <h3 className={Style.total}> : مبلغ نهایی</h3>
            </div>

            <Radio.Group
              onChange={onChange}
              value={value}
              className={Style.howPay}
            >
              <Radio value={"pgw"}>
                <div className={Style.PayTypeHolder}>
                  <img
                    src={`https://www.parsian-bank.ir/parameters/persian/modules/cdk/upload/content/general_content/244/32448E91-EDDB-4FB5-B996-0D2721CA272B__sis__ParsianBank-Logo.jpg`}
                    alt=""
                  />
                  <p>بانک پارسیان</p>
                </div>
              </Radio>
              <Radio value={"sadad"}>
                <div className={Style.PayTypeHolder}>
                  <img
                    src={`https://bayanbox.ir/view/505036785895245044/logo-bank-melli.jpg`}
                    alt=""
                    style={{objectFit:'contain'}}
                  />
                  <p>بانک ملی ایران</p>
                </div>
              </Radio>
              {/* <Radio value={"wallet"}>                  <div className={Style.PayTypeHolder}>
                    <img src={`https://www.farsroid.com/wp-content/uploads/Kifpool-Logo.png`} alt=""  />
                    <p>کیف پول</p>
                  </div></Radio> */}
            </Radio.Group>

            <div className={Style.btnHolder}>
              <button
                className={Style.btnPay}
                disabled={disablePay}
                onClick={sendToIdPay}
              >
                پرداخت
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};
export default FinalizePurchase;
